<template>
  <!-- eslint-disable vue/no-template-shadow -->
  <div class="member">
    <div class="profile">
      <span class="drop-down-menu profile-wrap">
        <div class="profile-img">
          <GImageUser
            :username="profile.user_name || null"
            :src="profile.image"
            class="img-user"
            class-name="avatar"
            :alt="profile.user_name || 'icon-default-avatar'"
            :user-level="profile.user_level"
            :is-expert-review="isExpertReview"
            :user="auth || null"
          />
        </div>
        <div class="profile-detail">
          <p class="name">{{ profile.first_name + ' ' + profile.last_name }}</p>
          <div class="username-wrapper">
            <a class="username">@{{ profile.user_name }}</a>
            <div v-if="profile.expert_role" class="expert-role">
              {{ convertName(profile.expert_role) }}
            </div>
          </div>
          <a :href="`${$store.state.SOCO_WEB_URL}/${profile.user_name}/timeline`" class="txt-danger"> View profile </a>
        </div>
      </span>
      <div id="soco-level-points" class="soco-level-points">
        <a :href="`${$store.state.SOCO_WEB_URL}/profile/points-rewards`" target="_blank" rel="noopener">
          <section class="soco-level">
            <img
              v-if="userLevelKebabCase"
              class="lazy-img"
              :src="`/assets/img/loyalty-point/${userLevelKebabCase}.svg`"
            />
            <img v-else class="lazy-img" src="/assets/img/loyalty-point/soco-star.svg" />
            <section>
              <p>Your Beauty Star</p>
              <img
                v-if="userLevelKebabCase"
                class="lazy-img user-level-caption"
                :src="`/assets/img/loyalty-point/${userLevelKebabCase}-caption.svg`"
              />
              <img v-else class="lazy-img user-level-caption" src="/assets/img/loyalty-point/soco-star-caption.svg" />
            </section>
          </section>
          <section class="soco-points">
            <section>
              <div class="points-container">
                <img src="/assets/img/icon_sp.svg" class="lazy-img sp-icon" />
                <p>Soco Points</p>
              </div>
              <span class="points">{{ auth.points.count || 0 }}</span>
            </section>
          </section>
          <img src="/assets/img/arrow-right-red.svg" width="24" />
        </a>
      </div>
    </div>

    <ul
      v-for="(section, sectionIndex) in items"
      :key="sectionIndex"
      :class="['menu', { 'bordered-section': sectionIndex === 0 }]"
    >
      <MenuMemberList v-for="(item, index) in section" :key="index" :item="item" />
    </ul>

    <ul class="menu-logout">
      <li>
        <a href="javascript:" class="logout" @click="logout">{{ logoutText }}</a>
      </li>
    </ul>
  </div>
</template>

<script>
import MenuMemberList from './MenuMemberList';
import Auth from '@/shared/auth';

export default {
  name: 'menu-member',

  components: { MenuMemberList },

  props: {
    items: { type: Array, default: () => [] },
    profile: { type: Object, default: () => {} },
  },

  data() {
    return {
      isLogout: false,
    };
  },

  computed: {
    logoutText() {
      return this.isLogout ? 'Logging out...' : 'Log Out';
    },
    auth() {
      return this.$store.state.auth;
    },
    isExpertReview() {
      return this.$store.state.auth.userProfile.is_expert_reviewer;
    },
    userLevelKebabCase() {
      if (
        this.$store.state.auth &&
        this.$store.state.auth.userProfile &&
        this.$store.state.auth.userProfile.user_level
      ) {
        return this.$store.state.auth.userProfile.user_level.toLowerCase().split(' ').join('-');
      } else {
        return 'soco-star';
      }
    },
  },

  methods: {
    logout() {
      this.isLogout = true;
      Auth.CentralAuth.logout();
    },
    convertName(name) {
      let result = '';
      result = name
        .split('_')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
      return result;
    },
  },
};
</script>
